<template>
    <div>
        <CRow>
            <CCol sm="12">
                <CButton @click="collapse=!collapse" color="primary" class="mb-2">
                    فیلتر داده‌ها
                </CButton>
                <CCollapse :show="collapse" :duration="400">
                    <CCard>
                        <CCardHeader>
                            <strong>گزینه‌های فیلتر</strong>
                        </CCardHeader>
                        <CCardBody>
                            <CRow>
                                <CCol sm="3">
                                    <label>از کاربر</label>
                                    <model-select :options="users" v-model="form.from_id.val" placeholder="انتخاب کنید">
                                    </model-select>
                                    <small class="form-text text-muted w-100">{{form.from_id.inv}}</small>
                                </CCol>
                                <CCol sm="3">
                                    <label>به کاربر</label>
                                    <model-select :options="users" v-model="form.to_id.val" placeholder="انتخاب کنید">
                                    </model-select>
                                    <small class="form-text text-muted w-100">{{form.to_id.inv}}</small>
                                </CCol>
                                <CCol sm="3">
                                    <label>نوع لاگ</label>
                                    <model-select :options="types" v-model="form.log_type.val" placeholder="انتخاب کنید">
                                    </model-select>
                                    <small class="form-text text-muted w-100">{{form.log_type.inv}}</small>
                                </CCol>
                                <CCol sm="3">
                                    <label>تاریخ</label>
                                    <date-picker placeholder="انتخاب کنید" v-model="form.created_at.val"></date-picker>
                                    <small class="form-text text-muted w-100">{{form.created_at.inv}}</small>
                                </CCol>
                            </CRow>
                            <br/>
                            <CRow>
                                <CCol sm="3">
                                    <CInput v-model="form.log_text.val" :description="form.log_text.inv" label="متن لاگ" />
                                </CCol>
                            </CRow>
                            <br>
                            <div class="form-group form-actions">
                                <CButton @click="validator();filter=true;page=1;get();" class="ml" color="primary">فیلتر</CButton>
                                <CButton @click="remove_filter" color="danger">حذف فیلتر</CButton>
                            </div>
                        </CCardBody>
                    </CCard>
                </CCollapse>
            </CCol>
            <CCol col="12" xl="12">
                <CCard>
                    <CCardHeader>
                        <strong>لاگ‌ها</strong>
                        <div class="card-header-actions">
                            تعداد: {{row_count}}
                        </div>
                    </CCardHeader>
                    <CCardBody>
                        <CCol sm="5">
                            <CSelect v-model="limit" horizontal label="تعداد سطرها" :options="[
                                {value: 10}, {value: 20}, {value: 50}, {value: 100}]" class="row-count" placeholder="تعداد سطرها" @change="limit=$event.target.value" />
                        </CCol>
                        <CDataTable hover striped :items="items" :fields="fields" :noItemsView="{ noItems: 'داده‌ای برای نمایش وجود ندارد' }">
                            <template #log_type="data">
                                <td><CBadge :color="get_badge(data.item.log_type)">{{data.item.log_type}}</CBadge></td>
                            </template>
                            <template #from_name="data">
                                <td v-if="data.item.from_id==0">{{data.item.from_name}}</td>
                                <td v-else>
                                    <router-link :to="`/profile/${data.item.from_id}`">
                                        {{data.item.from_name}}
                                    </router-link>
                                </td>
                            </template>
                            <template #to_name="data">
                                <td v-if="data.item.to_id==0">{{data.item.to_name}}</td>
                                <td v-else>
                                    <router-link :to="`/profile/${data.item.to_id}`">
                                        {{data.item.to_name}}
                                    </router-link>
                                </td>
                            </template>
                            <template #log_details="data">
                            <td>
                                <template>
                                <div class="flex-container">
                                    <div @click="log_details=data.item.log_info;log_modal=true"
                                        v-c-tooltip.hover="'جزییات'">
                                        <CIcon name="cilListRich" size="lg"/>
                                    </div>
                                </div>
                                </template>
                            </td>
                            </template>
                        </CDataTable>
                            <br>
                            <div> 
                                <CPagination
                                :activePage.sync="page"
                                :pages="page_count"
                                align="center"
                                :doubleArrows="true"
                                />
                            </div>
                        </CCardBody>
                </CCard>
            </CCol>
        </CRow>
        <CModal
			title="جزییات لاگ"
			size="xl"
			color="primary"
			:show.sync="log_modal"
			>
            <pre style="text-align:left;direction:ltr;">{{ JSON.stringify(this.log_details, null, '\t') }}</pre>
			<template #footer>
				<CButton @click="log_modal=false" color="primary">بستن</CButton>
			</template>
		</CModal>
    </div>
</template>

<script>
import { ModelSelect } from 'vue-search-select'
import validator from '../mixins'
export default {
    mixins: { validator },
    components: { ModelSelect },
    data() {
        return {
            row_count: '',
            items: [],
            fields: [
                { key: 'id', label: 'شناسه' },
                { key: 'from_name', label: 'از کاربر' },
                { key: 'to_name', label: 'به کاربر' },
                { key: 'ip', label: 'IP' },
                { key: 'log_type', label: 'نوع لاگ' },
                { key: 'created_at', label: 'تاریخ' },
                { key: 'log_details', label: 'عملیات' },
            ],
            collapse: false,
            form: {
                from_id: { val: '', inv: '', v: { max: 8 } },
                to_id: { val: '', inv: '', v: { max: 8 } },
                log_type: { val: '', inv: '', v: { max: 4 } },
                created_at: { val: '', inv: '', v: { max: 16 } },
                log_text: { val: '', inv: '', v: { max: 1024 } },
            },
            filter: false,
            disable: false,
            page: 1,
            page_count: 0,
            offset: 0,
            limit: 10,
            users: [{ value: 0, text: 'سیستم' }],
            types: [
                { value: '0', text: 'خطا' },
                { value: '1', text: 'ورود موفق' },
                { value: '2', text: 'ورود ناموفق' },
                { value: '3', text: 'خطا در اتصال به وب‌سرویس - IP معتبر نیست' },
                { value: '4', text: 'به‌روزرسانی توکن' },
                { value: '5', text: 'افزودن یک توکن جدید' },
                { value: '6', text: 'حذف کردن توکن از سیستم' },
                { value: '7', text: 'افزودن موفق کاربر به سیستم' },
                { value: '8', text: 'به‌روزرسانی کاربر در سیستم' },
                { value: '9', text: 'حذف کاربر در سیستم' },
                { value: '10', text: 'فراموشی رمز عبور' },
            ],
            log_modal: false,
            log_details: [],
        }
    },
    watch: {
        page: {
            handler() {
                this.get();
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        },
        limit: {
            handler() {
                this.page = 1;
                this.get();
            }
        }
    },
    mounted() {
        this.get();
        this.get_users();
    },
    methods: {
        get_badge(status) {
            switch (status) {
                default: return 'secondary';
            }
        },
        get_users() {
            this.axios.get('users/')
                .then(res => {
                    res.data.map(val => {
                        this.users.push({ value: val.id, text: `${val.id} - ${val.first_name} ${val.last_name}` });
                    });
                })
        },
        get() {
            if (this.disable == false) {
                let filter = '';
                if(this.filter){
                    for (const key in this.form) {
                        if(this.form[key].val != ''){
                            if (key == 'created_at') {
                                filter += `&${key}=` + this.$moment(this.form[key].val, 'jYYYY-jMM-jDD').locale('es').format('YYYY-MM-DD');
                            } else {
                                filter += `&${key}=` + this.form[key].val;
                            }
                        }
                    }
                }
                this.axios.get('user_logs/' 
                    + '?count=1' 
                    + filter)
                    .then(res => {
                        this.row_count = String(res.data.count).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        if(res.data.count > this.limit){
                            this.page_count = Math.ceil(res.data.count / this.limit);
                        } else {
                            this.page_count = 1;
                        }
                        this.offset = 0;
                        if(this.page != 1){
                            this.offset = (this.page * this.limit) - this.limit;
                        }
                    })
                .finally(() => {
                    this.axios.get('user_logs/' 
                        + '?limit=' + this.limit 
                        + '&offset=' + this.offset 
                        + filter)
                        .then(res => {
                            res.data.map(val => {
                                val.from_name = val.from_user_info['name'];
                                val.to_name = val.to_user_info['name'];
                                val.ip = val.log_info['remote_info']['remote_ip'];
                                val.log_type = val.log_info['log_string'];
                                val.created_at = this.$moment(val.created_at, 'YYYY-MM-DD HH:mm:ss').locale('fa').format('HH:mm:ss jYYYY-jMM-jDD');
                            });
                            this.items = res.data;
                        })
                })
            }
        },
        remove_filter() {
            for (const key in this.form) {
                this.form[key].val = '';
                this.form.inv = '';
            }
            this.disable = false;
            this.filter = false;
            this.page = 1;
            this.get();
        },
    },
    beforeCreate() {
        if (this.$store.state.perms.can_view_user_logs_page == false
            && this.$store.state.verif == false) {
            this.$router.push('/403')
        }
    },
}
</script>